<template>
  <v-row no-gutters>
    <v-col cols="12" sm="6" md="auto">
      <v-data-table
        dense
        :headers="headers"
        :items="chief_log"
        :search="search"
        sort-by="ship_name"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Chief Pilot Logs</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-dialog v-model="dialog" max-width="800px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on"
                  >New Log</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">Current Vessels</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-data-table
                      dense
                      :headers="headers_dt2"
                      :items="allRadioLog"
                      item-key="name"
                      hide-default-footer
                      class="elevation-1"
                    >
                      <template v-slot:item.action="{ item }">
                        <v-icon
                          small
                          class="mdi mdi-plus"
                          @click="addToLog(item)"
                        ></v-icon>
                      </template>
                    </v-data-table>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="blue darken-1" text @click="close">Close</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            small
            class="mdi mdi-border-color"
            @click.stop="editItem(item)"
          ></v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <v-dialog v-model="dlgEdit" max-width="800px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-for="header in headers"
                  :key="header.value"
                >
                  <v-text-field
                    v-if="
                      header.value != 'action' &&
                        header.type != 'dateNtime' &&
                        header.type != 'select'
                    "
                    v-model="editedItem[header.value]"
                    :label="header.text"
                    :disabled="header.disable"
                  ></v-text-field>
                  <v-menu
                    v-model="menu"
                    v-if="header.type === 'dateNtime'"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date"
                        v-if="header.type === 'dateNtime'"
                        :label="header.text"
                        prepend-icon="mdi mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date"
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                  <v-select
                    v-if="header.type === 'select'"
                    :items="countries"
                    v-model="editedItem[header.id]"
                    item-text="country_name"
                    item-value="country_id"
                    :label="header.text"
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="blue darken-1" text @click="close('dlgEdit')"
              >Close</v-btn
            >
            <v-btn color="blue darken-1" text @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "PilotLogDataTable",
  data: () => ({
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    dialog: false,
    dlgEdit: false,
    show: false,
    selected: null,
    countries: [],
    search: "",
    headers_dt2: [
      {
        text: "Vessel Name",
        align: "left",
        sortable: false,
        value: "vessel_name"
      },
      { text: "Voyage No.", value: "voyage_no" },
      { text: "DOA", value: "doa" },
      { text: "Actions", value: "action", sortable: false }
    ],
    headers: [
      {
        text: "Ship Name",
        align: "left",
        sortable: false,
        value: "vessel_name",
        disable: true
      },
      { text: "Voyage No.", value: "voyage_no", disable: true },
      { text: "Agent Name", value: "agent_name", disable: true },
      { text: "Last Port", value: "last_poc", id: "last_port", type: "select" },
      { text: "Next Port", value: "next_poc", id: "next_port", type: "select" },
      {
        text: "Bert. Date & Time",
        value: "datetime_berthed",
        type: "dateNtime"
      },
      { text: "FWD Draft", value: "fwd_draft" },
      { text: "After Draft", value: "after_draft" },
      { text: "Remarks", value: "remarks" },
      { text: "Actions", value: "action", sortable: false }
    ],
    editedIndex: -1,
    editedItem: {
      vessel_name: "",
      voyage_no: "",
      agent_name: "",
      last_port: "",
      next_port: "",
      datetime_berthed: "",
      fwd_draft: "",
      after_draft: "",
      remarks: ""
    },
    defaultItem: {
      vessel_name: "",
      voyage_no: "",
      agent_name: "",
      last_port: "",
      next_port: "",
      datetime_berthed: "",
      fwd_draft: "",
      after_draft: "",
      remarks: ""
    }
  }),

  computed: {
    ...mapState({
      chief_log: state => state.chief_log.chief_logs
    }),
    ...mapGetters("radio_log", ["allRadioLog"]),

    formTitle() {
      return this.editedIndex === -1 ? "New Log" : "Edit Log";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
      val ? this.$store.dispatch("radio_log/fetchRadioLog") : "";
    },
    dlgEdit(val) {
      if (val)
        this.$store.dispatch("countries/fetchCountries").then(res => {
          this.countries = res;
        });
    }
  },

  mounted() {
    this.$store.dispatch("chief_log/fetchChiefLogs");
  },

  methods: {
    initialize() {
      this.$store.dispatch("chief_log/fetchChiefLogs");
    },

    editItem(item) {
      this.editedIndex = this.chief_log.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dlgEdit = true;
    },

    addToLog(item) {
      if (!item) return;

      this.$store.dispatch("chief_log/saveChiefLog", item).then(res => {
        if (res.success) {
          this.$noty.success(res.success);
          this.initialize();
        } else
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.error
          });
        return;
      });
    },

    deleteItem(item) {
      //
    },

    close(e) {
      if (e == "dlgEdit") this.dlgEdit = false;
      else this.dialog = false;

      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        let data = {
          last_port: this.editedItem.last_port,
          next_port: this.editedItem.next_port,
          datetime_berthed: this.date,
          cplog_id: this.editedItem.cplog_id,
          remarks: this.editedItem.remarks,
          fwd_draft: this.editedItem.fwd_draft,
          after_draft: this.editedItem.after_draft
        };
        this.$store.dispatch("chief_log/updateChiefLog", data).then(res => {
          if (res.success) {
            this.initialize();
            this.$noty.success(res.success);
          } else {
            this.$noty.warning(res.error);
            return;
          }
        });
      } else {
      }
      this.close("dlgEdit");
    }
  }
};
</script>
